module.exports = __webpack_public_path__ + "img/delmonte.052babf0.png";